import { Controller } from '@hotwired/stimulus'

// #AI: jQuery is loaded via Sprockets as a global variable
const $ = window.jQuery || window.$;

export default class extends Controller {
  initialize() {
    if (!$) {
      console.error('[AutoAddQuestionController] jQuery not available');
      return;
    }
    let questions = document.getElementById('questions');
    let addQuestionButtonElement = document.getElementById('add_question_button')

    this.addQuestionButtonJqueryObject = $(addQuestionButtonElement)
    addQuestionButtonElement.addEventListener('click', this.openAddQuestionModal.bind(this))

    if (questions.children.length > 0) {
      return
    }

    this.openAddQuestionModal()

  }

  openAddQuestionModal(event) {
    if (event) event.preventDefault();

    this.addQuestionButtonJqueryObject.modal({ clickClose: false })
  }
}
